<template>
  <AuthLayout>
    <div class="nftmax-wc__form">
      <div class="nftmax-wc__form-inner">
        <div class="nftmax-wc__heading">
          <h3
            class="nftmax-wc__form-title nftmax-wc__form-title__four"
            style="
              background-image: url('../../assets/img/heading-vector-4.png');
            "
          >
            Verification Code
          </h3>
        </div>
        <!-- Sign in Form -->
        <form class="nftmax-wc__form-main" action="#" method="post">
          <div class="form-group">
            <label class="nftmax-wc__form-label">Verification Code</label>
            <div class="form-group__input">
              <el-input v-model="verificationCode" placeholder=""></el-input>
            </div>
            <div class="verification-info">
              <span>Enter the verification code that was sent to your email address</span>
            </div>
          </div>
          <div class="form-group">
            <div class="nftmax-wc__button">
              <el-button
                class="ntfmax-wc__btn"
                type="submit"
                :loading="isVerifying"
                @click="enterPassword"
              >
                Continue
              </el-button>
            </div>
          </div>
          <div class="form-group">
            <div class="nftmax-wc__bottom">
              <p class="nftmax-wc__text">
                Don't received a code? 
                <span v-if="countdown > 0" class="countdown-text">
                  Resend in {{ countdown }}s
                </span>
                <a
                  v-else
                  href="#"
                  class="resend-link"
                  :class="{ 'loading': isResending }"
                  @click.prevent="resendCode"
                >
                  {{ isResending ? 'Sending...' : 'Please resend' }}
                </a>
              </p>
            </div>
          </div>
        </form>
        <!-- End Sign in Form -->
      </div>
    </div>
  </AuthLayout>
</template>

<script>
import AuthLayout from "@/components/Auth/AuthLayout";
import api from "../../http/api";

export default {
  components: { AuthLayout },
  data() {
    return {
      verificationCode: "",
      countdown: 60, // 倒计时60秒
      countdownTimer: null,
      isResending: false,
      isVerifying: false,
    };
  },
  mounted() {
    this.$vToastify.success(
      "Verification code has been sent to the email address"
    );
    this.startCountdown();
  },
  beforeDestroy() {
    // 清理定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    async enterPassword() {
      try {
        if (this.verificationCode !== "") {
          this.isVerifying = true;
          this.$router.push({
            name: "UpdatePassword",
            params: {
              email: this.$route.params.email,
              verificationCode: this.verificationCode,
            },
          });
        } else {
          this.$vToastify.error("Please fill all fields");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isVerifying = false;
      }
    },
    async resendCode() {
      try {
        this.isResending = true;
        await api.sendCodeToEmail({
          email: this.$route.params.email,
        });
        this.$vToastify.success("Verification code has been resent to your email");
        this.startCountdown();
      } catch (error) {
        console.log(error);
        this.$vToastify.error("Failed to resend verification code, please try again");
      } finally {
        this.isResending = false;
      }
    },
    startCountdown() {
      this.countdown = 60;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.verification-info {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}

.countdown-text {
  color: inherit;
  font-size: inherit;
}

.resend-link {
  color: #409eff;
  text-decoration: none;
  font-size: inherit;
}

.resend-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.resend-link.loading {
  color: #999;
  cursor: not-allowed;
}

.resend-link.loading:hover {
  text-decoration: none;
}
</style>